export const LANGUAGES = [
  {id: 0, label: 'English (UK)', flag: 'gb', lang: 'en'},
  {id: 1, label: 'Bahasa Indonesia', flag: '360', lang: 'id'},
  {id: 2, label: 'தமிழ்', flag: 'sg', lang: 'sg'}
];
